import type {
  Conversation,
  ConversationHeaderResponse,
} from "~/conversations/types/conversation";

function mapConversationResponseToModel(
  response: ConversationHeaderResponse,
): Conversation {
  return {
    id: response.id,
    title: response.title,
    createdAt: new Date(response.created_at),
    updatedAt: new Date(response.updated_at),
    messages: [],
  };
}

export { mapConversationResponseToModel };
